module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Five.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-8"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER 5")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "sub"
  }, [_vm._v("Eleanor")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "caps-epub"
  }, [_vm._v("STRIDING DOWN THE ")]), _vm._v("aisle behind the crucifer and the deacon was a man—a man with blond hair and a god’s face. He looked forward with eyes so serious and solemn she followed his gaze to the altar to see if Jesus waited for him there.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As he stepped past her pew he turned his head and met her eyes for the briefest of eternities. The book within her missal fell from her hand and fluttered to the floor. She didn’t bend to pick it up. It lay there, forgotten, as forgotten as everyone and everything else in this world. Everyone and everything else but this man who now mounted the steps to the altar and stood before the church.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Underneath the collar of his vestments she saw the hint of black with the white square.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This man, this most beautiful man she’d ever seen in her life, this man who was the incarnation of her every hunger, every desire and every secret midnight dream… This man was her new priest?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, my God…” she breathed, but whether she addressed the God in Heaven or the God before her, she didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She crossed herself when the church crossed themselves. She remained standing as they remained standing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“In the name of the Father, and of the Son, and of the Holy Spirit,” the new priest intoned, and together with the congregation Elle answered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His voice, rich and resonant, echoed out to the very edges of the church and back again. His words wrapped around her like a golden cord binding her to him. The sanctuary brightened with each word he spoke as if the sun itself drew closer to hear his voice. Once in winter she’d seen a man on a street corner playing an old cello for coins. A cello on a winter night in the midst of a frozen city—that was what his voice sounded like.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sat when the congregation sat and even as she sat down, her heart rose.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A woman read from the Old Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A man read from the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The priest read from the Gospels.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She heard none of the words. She heard only music. Even when the hymns had been sung and ended, she still heard music.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She knelt when the church knelt and prayed when the church prayed. And when it came time to rise for the Eucharist, she rose again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("On feet she could no longer feel she made her way inexorably toward the altar. Although she walked of her own volition, she felt drawn. That golden cord had wrapped itself around her heart and she would go wherever it led her. It led her to him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With every step closer to him, the cord tightened, and yet the tighter it bound her, the greater her joy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Visions flashed through her mind. A fluttering of white wings. A burning arrow. Stained glass under her feet. His hands on her face. His mouth on her mouth. His mouth on her breasts. His skin against her skin. His body inside her body. His heart in her heart in his hands…")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("From the deacon she took the wafer, said her Amen and swallowed it whole.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("From the priest, she took the cup of wine. As she raised the cup to her lips, the sleeve of her shirt fell back, baring her arm and the two red burns on her wrist. She met his eyes and saw something flash in them, something she couldn’t translate into words. It was as if he recognized her, as if he’d seen her before somewhere and now tried to remember where. She knew she’d never seen him before in her life. If she had, she would never have forgotten him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The golden cord knotted itself tighter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The blood of Christ,” he whispered, softer than he’d spoken it to anyone else, so softly she leaned in closer to hear him better.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Their fingers touched as she returned the cup to him, and she soared back to her seat. She picked her novel off the floor, closed it and stuffed it in her backpack.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Mass ended. All were exhorted to go forth in peace. But Eleanor felt no peace and she would feel no peace until she’d spoken to him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Him? Him who? When she reached the lobby of the church, Elle realized she had no idea what the new priest’s name was. She had to know. Now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She saw her mother whispering to a group of older women by the annex door. Probably talking about how the new priest was too young, too inexperienced, too handsome. As if there could be such a thing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a nice day. I’m walking home,” she said to her mother and beat a hasty retreat before her mother could even say a word in argument.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The entire congregation surrounded their new priest. And yet she could still see him. He towered over most of them. He had to be six feet tall or more. Over the top of the crowd he met her eyes as if he’d been searching for her in the crowd. She mouthed, “I’ll wait for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She slipped out the side door and watched the cars filing out. Soon nothing remained in the parking lot but a gleaming black motorcycle. Even on the opposite side of the parking lot she could make out the lines of it, the chrome detailing shining in the March sunlight. She’d never seen anything more beautiful in her life except for the man crossing the pavement toward it. Careful to make as little sound as possible, she stepped from the shadows and followed him to his motorcycle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d abandoned the vestments for black clerics. Father Greg had always worn a plain black shirt and black jacket over it, usually without the white collar in place. But this priest had on a more formal looking and heavier black clerical shirt. It looked European to her. She’d never seen a priest who looked so… She couldn’t find the right word. Elegant, maybe?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As he reached his motorcycle, he paused but didn’t turn around.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was wondering where you went,” he said, taking his helmet off the handlebars. He turned around and faced her. “You said you’d wait for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re kind of an idiot. You know that, right?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He raised his eyebrow at her. Elle dug her hands in her pocket and stared at him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Am I?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He sat astride his motorcycle, and she stepped in front of it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you have any idea what it is you have between your legs?” she demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m well aware of what is between my legs.” He said the words without even breaking a smile. She narrowed her eyes at him and stepped closer, straddling the front wheel with her knees.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then you know that this is a Ducati. A 907 I.E.,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s in black. Never seen one in black before.” She walked a circuit around the bike. “Do you have any idea how much this Duck is worth?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A small fortune, I’d imagine.” He put the helmet back on the handlebars.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah. A small one. So where’s your lock?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your disc lock. You can’t leave a Ducati sitting in a parking lot without a lock on it unless you’re criminal stupid or you want it to get stolen. Which one is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Criminally stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So you admit it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I’m correcting your grammar. And I didn’t realize suburban Connecticut was such a high-crime district. Should I be afraid?” He asked the question in a tone that implied he knew what fear was, but only in theory, not practice.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If I had something that valuable, I’d lock it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He smiled at her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I plan to.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s good. Okay, then.” She stood there not knowing what else to say. The few things that leaped to mind were a little too forward. Like “I love you” and “will you marry me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tell me your name.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Elle.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is that short for…?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Eleanor. Eleanor Louise Schreiber, at your service.” She grasped the ends of her skirt and gave him her most sarcastic curtsy. “Now who the hell are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Try that again. More politely please.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tapped the toe of her boot on the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fine. What is your name, Father?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He studied her face for a moment and didn’t answer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t you know your own name?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m deciding how to answer the question. In the meantime, allow me to say this. It is a pleasure to finally meet you, Eleanor.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He reached out his left hand for her to shake. She had no choice but to give him her own left hand. As soon as her hand was in his, he gripped her fingers and pulled her toward him. He pushed at her sleeve and examined the two burns on her wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, what the hell are you doing?” she demanded, trying to pull her arm back. He didn’t give an inch, merely held her in place with his impossible strength.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You have two second-degree burns on your arm and large scrapes on your knees. Care to tell me how those came about?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s none of your business.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The priest studied her through narrowed steel-colored eyes. He didn’t seem the least offended by her language.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Eleanor,” he said. “Tell me who hurt you. And tell me right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She felt the force of his will like a wall pressing against her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No. You won’t even tell me your name.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If I tell you my name, will you tell me about the burns?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He let her hand go and she pulled her arm back and held it to her stomach. Her entire body fluttered from the touch of his hand on her hand, and the unrepentant way he studied her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She stood still and silent while he stared at her face until she reluctantly met his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Will you tell anybody what I tell you?” She wasn’t wild about telling anyone something so private about herself, but for some reason, a reason she couldn’t name, she trusted this man, this priest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not a soul.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay. Fine. Name?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He reached into the black leather saddlebag on his motorcycle and pulled out what appeared to be a Bible in some foreign language. He flipped opened the well-worn cover to a page where he’d written his name in thick black ink with strong legible handwriting.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Søren Magnussen.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She reached out and with the tip of her finger traced the letters in the name.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Søren… Did I say that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You say it like an American.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How am I supposed to say it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I like the way you say it. You should know, that’s not the name anyone here will ever call me. That’s what my mother named me. Unfortunately I’m forced to go by what my father named me—Marcus Stearns.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So no one here knows your real name?” That he wrote Søren Magnussen in his Bible seemed to hint that he considered Søren his real name, not Marcus.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Only you. And now that you know it, I believe you owe me an answer to my question.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not a big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Eleanor—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I go by Elle, not Eleanor.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Eleanor is the name of queens. Elle is merely a French pronoun that means "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her.")]), _vm._v(" I will call you Eleanor. And now, Eleanor, tell me how you arrived at the burns on your wrist. Then we’ll discuss the knees.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Curling iron.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Self-inflicted or is someone in your home hurting you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Self-inflicted.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why did you do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You enjoy hurting yourself?” He asked the question without shock or disgust. She heard nothing in his voice but curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You think I’m crazy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You seem quite sane to me. Apart from your clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What? Not down with grunge?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your hair is also a cause for concern.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s wrong with my hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s gone green.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not moldy,” she said, laughing at the playful look of disapproval on his face. “That’s hair gel. I put green streaks in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How old are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fifteen. But I’ll be sixteen in two weeks.” She felt the need to add that part at the end. “My mom says you’re too young to be a priest.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m twenty-nine. But I’ll try to age very quickly for her. I’m certain pastoring at a church you attend will age me considerably.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll do my best.” She grinned broadly at him as she toyed with the cuffs of her jacket. Once more she fell into an awkward silence. He didn’t seem awkward at all. He seemed to be having the time of his life watching her be weird in front of him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Now for the knees. Those are impressive-looking wounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I fell,” she said. “Shit happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t seem the clumsy sort. Perhaps I was mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She pursed her lips. Her? Clumsy?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not clumsy. Ever. My gym teacher said I move like a trained dancer.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So then where did the injuries to your knees come from?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I got in a fight at school.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hope she looks worse than you do.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He,” she said with pride. “He looks fine. But he’s still walking funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Søren’s eyes widened slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You fought with a boy at your school?” He sounded mildly horrified.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not my fault. There’s this girl at school—Pepper Riley. And if her name wasn’t bad enough, she has huge boobs. She’s scared of her own shadow and won’t fight back. So this guy, Trey, he was being a prick to her on the bus saying all kinds of gross shit about her body. So I told him to shut up. And then he starts saying gross shit to me. He was all, ‘I want your body, Elle.’ So I said he could have my body. Then I gave him my foot. Right in the nuts. It was kind of amazing. When we got off the bus he pushed me so hard I landed on my knees and ripped them open. Whatever. Typical Wednesday at your local Catholic high school. Your tax dollars not at work.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He continued to stare at her. His eyes had widened even farther.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Father Stearns? Søren? Whoever you are?” She waved her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Forgive me. I was utterly riveted by your story. I might have entered a fugue state.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lucky for me, it all happened at the back of the bus and the driver didn’t see it. Otherwise Vice Principal Wells would have my ass. He told me if I got sent to his office one more time I’d be publicly crucified as an example to the rest of the school. I think he was kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you deserve such a threat?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe. I said in class that St. Teresa didn’t have a mystical experience but was, in fact, having an orgasm. It’s not like I didn’t prove it. She said the angel ‘penetrated’ her with his ‘flaming arrow’ right to her ‘entrails’ and that it gave her ‘ecstasy.’” Elle used air quotes for emphasis. “That was not a mystical experience. That was a big O. V.P. Wells didn’t appreciate my theology.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I appreciate your theology.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eleanor opened her mouth and then closed it again. She had zero words. None. Nothing. She had no idea what to say to that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going to go away now,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You want me to stay?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked at him askance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No one ever wants me to stay. You know, after I start talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I want you to stay,” he said. “And I’d like you to keep talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not interrupting your golf game?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Golf?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All priests play golf, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not this priest.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you play?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Other games.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Something in the way he said the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("games")]), _vm._v(" made Elle’s toes curl up inside her combat boots.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then I should let you get back to your other games.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do one thing for me before I leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Take your hair down.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This time she didn’t even argue or ask why. She simply pulled the elastic out of her hair, ran her fingers through the messy waves and dropped her hands to her side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Give me your right hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He held out his hand again and he took her unburned wrist in his fingers. From her left hand he took her ponytail holder and wrapped it around her wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Slipping two fingers between the band and her wrist, he lifted it high and let it go, snapping the sensitive skin so hard she flinched.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fuck…Jesus, that hurt. What did you do that for?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Those burns on your wrist will take months to heal completely. There are other ways of inflicting pain on yourself that don’t leave scars. You should learn them.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Elle looked down at her wrist. Her skin still reverberated with the pain of the vicious sting, but the redness had already started to fade.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you… You just…”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your body is a temple, Eleanor. You should treat it like the priceless and holy vessel it is. I learned one thing and one thing only from watching my father’s wife. If you’re going to redecorate, either learn how to do it properly, or hire a professional.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He took his helmet off the handlebars and started the motorcycle. Its impressive engine roared to life and Eleanor felt the vibrations from the ground up to her stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not a normal priest, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gave her a smile that hit her like a slap to the face and a kiss on the mouth all at once.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My God, I hope not.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With those final words, he put on his helmet and kicked out the stand with his heel. Eleanor took three giant steps back. He rode out of the parking lot and left her standing there alone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She watched him until he disappeared from view. And then she listened until the sound of his engine retreated into silence.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m yours, Søren,” she said to no one but God, and didn’t know what she meant by it. She only knew it was true.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was his whatever the consequences. She was his.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Amen. Amen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So be it.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-7"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afbd520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter05.vue
// module id = 78
// module chunks = 0